<template>
  <div class="margin-general discover_">
    <div class="img_">
      <NuxtImg
        :src="imageSrc"
        alt="Tracking gold, oil, Bitcoin prices"
        width="468"
        height="539"
        class="discover-img"
        format="webp"
        quality="85"
        loading="lazy"
        sizes="sm:100vw md:70vw lg:512"
      />
      <span class="visually-hidden">Tracking gold, oil, Bitcoin prices</span>
    </div>
    <div class="title">
      <h3 class="heading-h3">{{ $t("market.titlediscov") }}</h3>
      <p class="body-4">{{ $t("market.descriptdiscov") }}</p>
    </div>
    <div class="items-cont">
      <div class="item" v-for="item in marketItems" :key="item.id">
        <span class="material-symbols-outlined" translate="no">{{ item.icon }}</span>
        <div class="descript_">
          <p class="body-3">{{ $t(item.title) }}</p>
          <p class="body-4">{{ $t(item.description) }}</p>
        </div>
      </div>
    </div>
    <a class="second-button-small" target="_blank" :href="getExternalUrl('/register/1/live-account')" rel="noopener noreferrer">{{ $t("market.linkdiscov") }}</a>
  </div>
</template>

<script setup>
import { computed} from 'vue';
import { useI18n } from "vue-i18n";
import { useNuxtApp } from '#app';
import { useExternalUrl } from '@/composables/useExternalUrl';

const {getExternalUrl} = useExternalUrl();

const props = defineProps({
  imageSrc: {
    type: String,
    required: false
  },
  imgWidth: {
    type: [String, Number],
    default: 'auto'
  },
  imgHeight: {
    type: [String, Number],
    default: 'auto'
  }
});

const { locale } = useI18n();
const { $regulationsVar } = useNuxtApp();

const marketItems = [
  {
    id: 1,
    icon: "database",
    title: "market.titleitem1",
    description: "market.titledescript1",
  },
  {
    id: 2,
    icon: "oil_barrel",
    title: "market.titleitem2",
    description: "market.titledescript2",
  },
  {
    id: 3,
    icon: "currency_bitcoin",
    title: "market.titleitem3",
    description: "market.titledescript3",
  },
];

const config = {
  'ko': {
    image: '/images/market/03.Markets-Img2-Kor.png',
  },
  'zh': {
    image: '/images/market/03.Markets-Img2-Ch.png',
  },
  'pt-br': {
    image: '/images/market/03.Markets-Img2-Br.png',
  },
  'LATAM': {
    image: '/images/market/03.Markets-Img-mx.png',
  },
  'es': {
    image: '/images/market/03.Markets-Img-mx.png',
  },
  'default': {
    image: '/images/market/Markets-Img.png',
  }
};

const currentRegulation = computed(() => $regulationsVar.getRegulation(locale.value));

const imageSrc = computed(() => {
  return config[locale.value]?.image || config[currentRegulation.value]?.image || config['default'].image;
});
</script>